import ImagesUrl from "#constants/images.js";
import React, { useState } from "react";

const CropProtectionComponent = ({
  values,
  handelModalOpen,
  removeSelectedProduct,
  parentIndex,
}) => {
  const [productDetailIndex, setProductDetailIndex] = useState(null);
  return (
    <div className="custom_accordion_item">
      <button
        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#collapseCrop_3${parentIndex}`}
        aria-expanded="false"
        aria-controls={`collapseCrop_3${parentIndex}`}
      >
        <p className="m-0 fertility_text">Crop Protection</p>
        <span className="drop_icon">
          <img
            className="drop_icon"
            src={ImagesUrl.dopeIcon}
            alt="drop-icon .."
          />
        </span>
      </button>
      <div
        className="custom_collapse_body collapse"
        id={`collapseCrop_3${parentIndex}`}
      >
        <div className="common-collapse_blk">
          <div className="row gy-4">
            {values?.data[parentIndex]?.cropProtection?.map(
              (cropProtectionItem, cropProtectionIndex) => {
                return (
                  <div className="col-lg-12" key={cropProtectionIndex}>
                    <div className="custom_sub_accordion_item">
                      <button
                        className="custom_accordion d-flex w-100 justify-content-between align-items-center border-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapseCropProtection_${cropProtectionIndex}${parentIndex}`}
                        aria-expanded="false"
                        aria-controls={`collapseCropProtection_${cropProtectionIndex}${parentIndex}`}
                      >
                        <p className="m-0 fertility_text fs-6">
                          {cropProtectionItem?.cropTitle}
                        </p>
                        <span className="drop_icon">
                          <img
                            className="drop_icon"
                            src={ImagesUrl.dopeIcon}
                            alt="drop-icon .."
                          />
                        </span>
                      </button>
                      <div
                        className="custom_collapse_body collapse"
                        id={`collapseCropProtection_${cropProtectionIndex}${parentIndex}`}
                      >
                        <div className="common-collapse_blk sub-collapse_blk">
                          <div className="row gy-4">
                            <div className="added_product_outer_wrapper">
                              {cropProtectionItem?.cropDetail?.length > 0 ? (
                                cropProtectionItem?.cropDetail?.map(
                                  (productItem, productIndex) => {
                                    const isActive =
                                      productDetailIndex ===
                                      `${parentIndex}-${cropProtectionIndex}-${productIndex}`;
                                    return (
                                      <div
                                        className="added_product_group mb-3"
                                        key={productIndex}
                                      >
                                        <div
                                          className="added_product_card p-3"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            gap: "10px",
                                            width: "100%",
                                          }}
                                        >
                                          {/* Product Name */}
                                          <h3
                                            style={{
                                              margin: 0,
                                              flex: 1,
                                              fontSize: "16px",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              whiteSpace: "nowrap",
                                              maxWidth: "70%",
                                            }}
                                          >
                                            {productItem?.productName}
                                          </h3>

                                          {/* Action Buttons */}
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                              flexShrink: 0,
                                              minWidth: "90px",
                                              justifyContent: "flex-end",
                                            }}
                                          >
                                            <svg
                                              onClick={() => {
                                                handelModalOpen(
                                                  parentIndex,
                                                  cropProtectionIndex,
                                                  "edit",
                                                  productItem,
                                                  productIndex,
                                                );
                                              }}
                                              width="23"
                                              height="23"
                                              viewBox="0 0 23 23"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                              style={{ cursor: "pointer" }}
                                            >
                                              <path
                                                d="M12.3125 3.34264L4.68897 11.4119C4.40112 11.7184 4.12254 12.3219 4.06683 12.7398L3.72326 15.7484C3.60254 16.8348 4.38254 17.5776 5.45969 17.3919L8.44969 16.8812C8.86755 16.8069 9.45254 16.5005 9.7404 16.1848L17.364 8.1155C18.6825 6.72264 19.2768 5.13478 17.2247 3.19407C15.1818 1.27193 13.6311 1.94978 12.3125 3.34264Z"
                                                stroke="#292D32"
                                                strokeWidth="1.5"
                                              />
                                            </svg>

                                            <img
                                              style={{ cursor: "pointer" }}
                                              onClick={() =>
                                                removeSelectedProduct(
                                                  parentIndex,
                                                  cropProtectionIndex,
                                                  productIndex,
                                                )
                                              }
                                              src={ImagesUrl.deleteIcon}
                                              alt="delete"
                                            />

                                            <button
                                              className="drop_icon"
                                              onClick={() =>
                                                setProductDetailIndex(
                                                  isActive
                                                    ? null
                                                    : `${parentIndex}-${cropProtectionIndex}-${productIndex}`,
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                        {isActive && (
                                          <div className="added_product_card_detail d-block">
                                            <div className="added_product_card_header">
                                              <h4>Detail</h4>
                                            </div>
                                            <div className="added_product_card_info">
                                              <div className="added_product_content flex_between_blk">
                                                <div className="added_product_content flex_between_blk">
                                                  <h4>Rate:</h4>
                                                  <p>
                                                    {productItem?.rate}{" "}
                                                    {productItem?.rateUnit}
                                                    /{productItem.containerSize || ""} {productItem.containerUnit || ""} {productItem.containerType || ""}
                                                  </p>
                                                </div>
                                              </div>
                                              <div className="added_product_content flex_between_blk">
                                                <h4>Note:</h4>
                                                <p>{productItem?.notes}</p>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    );
                                  },
                                )
                              ) : (
                                <div className="col-12 text-center mt-2">
                                  <p className="mb-0 mt-3">
                                    No products available.
                                  </p>
                                </div>
                              )}
                            </div>

                            <div className="col-12">
                              <button
                                onClick={() => {
                                  handelModalOpen(
                                    parentIndex,
                                    cropProtectionIndex,
                                    "add",
                                  );
                                }}
                                className="outline_btn_style bg-transparent"
                              >
                                + Add Product
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              },
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CropProtectionComponent;
